<template>
  <div v-if="!mode" class="intra-transfer-wrapper margin-bottom-120">
    <h2>CRRYPTOCURRENCY WITHDRAWAL</h2>

    <div class="form-wrapper">
      <span>WHAT CRYPTOCURRENCY AND HOW MUCH WILL YOU WITHDRAW?</span>
      <div class="fields">
        <div class="field">
          <span>SELECT CRYPTOCURRENCY</span>
          <el-select
            class="fields__select"
            v-model="firstSelected"
            filterable
            placeholder="Select currency"
            no-data-text="List is empty"
          >
            <el-option
              v-for="item in currencies"
              :key="item.name"
              :label="`${item.name} ${item.fullName}`"
              :value="item.name"
            >
              <img :src="`/${item.name}.svg`" />
              <span>{{ item.name }} {{ item.fullName }}</span>
            </el-option>
          </el-select>
        </div>
        <div class="field">
          <span>DESTINATION {{ firstSelected }} ADDRESS</span>
          <el-select
            class="fields__select"
            v-model="secondSelected"
            filterable
            placeholder="Select address"
            no-data-text="List is empty"
          >
            <el-option
              v-for="item in accountDetails"
              :key="item.id"
              :label="
                `${item.account_special_number} (${item.currency_abbreviation}) (${item.balance})`
              "
              :value="item.account_special_number"
            >
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="fields">
        <div class="field">
          <span>ADDRESS LABEL (OPTIONAL)</span>
          <el-select
            class="fields__select"
            v-model="secondSelected"
            filterable
            placeholder="Select method"
            no-data-text="List is empty"
          >
            <el-option
              v-for="item in accountDetails"
              :key="item.id"
              :label="
                `${item.account_special_number} (${item.currency_abbreviation}) (${item.balance})`
              "
              :value="item.account_special_number"
            >
            </el-option>
          </el-select>
        </div>
        <div class="field">
          <span>AMOUNT IN {{ firstSelected }}</span>
          <el-input
            class="fields__input"
            placeholder="Amount"
            v-model="amount"
            type="number"
          />
          <span v-if="firstSelected" class="align-self-end"
            >Avaliable:
            <span class="text-blue">{{ firstSelected }} 60.00</span></span
          >
        </div>
      </div>

      <div class="button-wrapper">
        <el-button
          @click="confirmTransfer"
          :loading="loadingSubmitButton"
          type="primary"
        >
          CONTINUE
        </el-button>
      </div>
    </div>
  </div>
  <div
    v-else-if="mode === 'confirm'"
    class="intra-transfer-wrapper margin-bottom-120"
  >
    <div class="central-block">
      <h3>DO YOU CONFIRM TRANSACTION?</h3>
      <div class="fields" style="margin: 0;">
        <el-button @click="cancelTransfer" class="cancel-button">
          CANCEL
        </el-button>
        <el-button
          @click="sendTransferMock"
          :loading="loadingSubmitButton"
          type="primary"
        >
          CONFIRM
        </el-button>
      </div>
    </div>
  </div>
  <div v-else class="intra-transfer-wrapper margin-bottom-120">
    <div class="central-block">
      <img src="@/assets/ok-sign.svg" class="ok-sign" />
      <h3>EXCHANGE HAS BEEN EXECUTED SUCCESSFULLY</h3>
      <span @click="cancelTransfer" style="cursor:pointer;" class="text-blue"
        >Back to exchange</span
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { currencies } from "@/utils/currencies.js";

export default {
  data() {
    return {
      firstSelected: null,
      currencies: currencies,
      secondSelected: null,
      amount: null,
      reference: null,
      checked: false,
      loadingSubmitButton: false,
      showErrorMessage: false,
      mode: null,
    };
  },

  methods: {
    sendTransferMock() {
      this.mode = "done";
    },
    cancelTransfer() {
      this.mode = null;
      this.firstSelected = null;
      this.secondSelected = null;
      this.amount = null;
    },
    confirmTransfer() {
      const { firstSelected, secondSelected, amount } = this;

      if (!firstSelected || !secondSelected || !amount) {
        this.showErrorMessage = true;
        this.$message({
          message: "all fields must be filled",
          type: "warning",
        });
        return;
      }

      this.mode = "confirm";
    },
    async sendTransfer() {
      const { firstSelected, secondSelected, amount, reference } = this;

      if (!firstSelected || !secondSelected || !amount || !reference) {
        this.showErrorMessage = true;
        this.$message({
          message: "all fields must be filled",
          type: "warning",
        });
        return;
      }
      this.loadingSubmitButton = true;

      await this.$store
        .dispatch("sendIntraTransfer", {
          amount,
          from_account: firstSelected,
          to_account: secondSelected,
          reference,
        })
        .then((data) => {
          if (data.code === 500 || data.message) {
            this.$message({
              message: data.message,
              type: "warning",
            });
          } else {
            this.firstSelected = null;
            this.secondSelected = null;
            this.amount = null;
            this.reference = null;
            this.checked = false;

            this.$message({
              message: "Payment order was created",
              type: "success",
            });
          }
          this.loadingSubmitButton = false;
        });
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    accountDetails() {
      return this.$store.getters.accountDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
.intra-transfer-wrapper {
  padding: 25px;
  font-family: "WorkSans-Regular";
  width: 820px;
  @media screen and (max-width: 955px) {
    height: auto;
  }
}
.intra-transfer-wrapper {
  h2 {
    font-size: 22px;
    @media screen and (max-width: 1320px) {
      text-align: center;
    }
    @media screen and (max-width: 1180px) {
      font-size: 18px;
    }
    @media screen and (max-width: 550px) {
      font-size: 14px;
    }
    @media screen and (max-width: 400px) {
      font-size: 11px;
    }
  }
}
.form-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;

  & > * {
    margin: 15px 0;
  }

  @media screen and (max-width: 955px) {
    align-items: center;
    padding: 20px 10px;
  }
}

.fields {
  display: flex;
  margin-bottom: 25px;
  @media screen and (max-width: 1180px) {
    flex-direction: column;
  }
  &__select,
  &__input {
    width: 300px;
    margin-right: 25px;

    @media screen and (max-width: 955px) {
      width: 100%;
      margin-right: 0;
      margin-right: 0px;
      margin-left: 0px;
      margin-bottom: 10px;
    }
  }
  @media screen and (max-width: 955px) {
    flex-direction: column;
  }
}

.button-wrapper {
  display: flex;
  width: 100%;
  margin-top: 10px;
}

.el-button--primary {
  color: #fff;
  background: #4a44f2;
  border: 2px solid #4a44f2;
}

.field {
  display: flex;
  flex-direction: column;
  span {
    margin: 15px 0;
  }
}

.align-self-end {
  align-self: flex-end;
}

.central-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: space-evenly;
  border: 1px solid #dcdcdc;
  border-radius: 3px;
  width: 400px;
  height: 230px;
  padding: 15px;
  margin: 50px auto;
}

.ok-sign {
  width: 42px;
  height: 42px;
}
.text-blue {
  color: #4a44f2;
}
.el-select-dropdown__item {
  display: flex;
  align-items: center;
  & > * {
    margin-right: 10px;
  }
}

.cancel-button {
  border: 1px solid #4a44f2;
  color: #4a44f2;
  background: #fff;
}
</style>
